import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';

const VariationsStyles = createGlobalStyle`
@font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 

  .generated-images-holder-var15 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1080px;
  }
  .image-holder-var15 {
    width: 100%;
    display: flex;
    position: relative;
    flex: 1;
    min-height: 0;
  }

  .holder-inner-var15 {
    height: 1080px;
    display: flex;
    flex-direction: column;
  }

  .left-div-var15, .right-div-var15 {
    width: 50%;
    position: relative;
  }

  .top-text-var15 {
    width: 100%;
    background-color: white;
    padding: 23px 37px 20px;
    font-size: 55px;
    line-height: 1.25;
    color: #1C2327;
    font-family: CustomArial;
  }

  .break-var15 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
    &--black-var15 {
      background-color: black;
    }
  }
  .left-text-var15, .right-text-var15 {
    position: absolute;
    width: 100%;
    padding: 0 10px;
    bottom: 70px;
    font-size: 45px;
    line-height: 1.2;
    text-align: center;
    color: #000;
    font-weight: 400;
    font-family: CustomArial;
    -webkit-text-shadow: 1.5px 0 0 #000;
    -moz-text-shadow: 1.5px 0 0 #000;
    -ms-text-shadow: 1.5px 0 0 #000;
    -o-text-shadow: 1.5px 0 0 #000;
    text-shadow: 1.5px 0 0 #000;
    letter-spacing: 1.2px;
    &--top-var15 {
      bottom: auto;
      top: 70px;
    }
    p {
      background-color: white;
      display: inline-block;
      margin: 0;
      padding: 14px 40px 16px;
    }
    p.custom-brakes-var15 {
      white-space: nowrap;
    }
  }

  .left-text__divider-var15 {
    padding: 0 13px 0 7px;
  }

  .right-text__divider-var15 {
    padding: 0 7px 0 13px;
  }

  .image-var15 {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .left-actual-photo-var15 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .left-actual-photo-var15--top {
    top: 0;
    bottom: auto;
  }
  .right-actual-photo-var15 {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 72px;
  }
  .right-actual-photo-var15--top {
    top: 0;
    bottom: auto;
  }

  .watermark-var15 {
    position: absolute;
    bottom: 20px;
    right: 33px;
  }
`;

export default VariationsStyles;
